import React from "react";

import { Switch, Route } from "react-router-dom";
import StudentFees from "./StudentFees";
import TeacherSalaries from "./TeacherSalaries";
import StaffSalaries from "./StaffSalaries";
import DebtPayments from "./DebtPayments";
import DirectExpenses from "./DirectExpenses";
import IndirectExpenses from "./IndirectExpenses";
import RevenueAccounts from "./RevenueAccounts";
import MiscIncomes from "./MiscIncomes";
import ProjectsIncomes from "./ProjectsIncomes";
import GrantsIncomes from "./Grants";

const Lists = () => {
  return (
    <div className="finance-list-area">
      <Switch>
        <Route path="/mis/expenses/5" render={() => <DebtPayments />} />
        <Route path="/mis/expenses/4" render={() => <IndirectExpenses />} />
        <Route path="/mis/expenses/3" render={() => <DirectExpenses />} />
        <Route path="/mis/expenses/2" render={() => <StaffSalaries />} />
        <Route path="/mis/expenses/1" render={() => <TeacherSalaries />} />
        <Route path="/mis/revenues/1" render={() => <StudentFees />} />
        <Route path="/mis/revenues/1" render={() => <StudentFees />} />
        <Route path="/mis/revenues/2" render={() => <ProjectsIncomes />} />
        <Route path="/mis/revenues/3" render={() => <GrantsIncomes />} />
        <Route path="/mis/revenues/4" render={() => <RevenueAccounts />} />
        <Route path="/mis/revenues/5" render={() => <MiscIncomes />} />
      </Switch>
    </div>
  );
};

export default Lists;
